import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propChildren, propStr, propFunc, propArrayShape, } from '../../../helpers/custom-prop-types';
import { compose } from '../../../helpers/recompose';
import ModalHoc from '../Modal/ModalHoc';
const ConsultantSearchSuggestPopper = (props) => {
    const { className, modalState, onClick, suggests, title } = props;
    return (_jsx("div", Object.assign({ className: clsx('consultant-search-suggest-popper', className, modalState) }, { children: _jsxs("ul", { children: [title && (_jsx("li", { children: _jsx("strong", Object.assign({ className: 'strong' }, { children: title })) })), suggests.map(({ label, value }) => (_jsx("li", { children: _jsx("button", Object.assign({ className: 'row', onClick: onClick, type: 'button', value: value }, { children: label })) }, value)))] }) })));
};
ConsultantSearchSuggestPopper.propTypes = {
    className: propStr(),
    modalState: propStr().isRequired,
    onClick: propFunc().isRequired,
    suggests: propArrayShape().isRequired,
    title: propChildren(),
};
ConsultantSearchSuggestPopper.defaultProps = {
    className: '',
    title: undefined,
};
const enhance = compose(ModalHoc);
export default enhance(ConsultantSearchSuggestPopper);
